import { render, staticRenderFns } from "./BankConfigureMollieTerminal.vue?vue&type=template&id=cb570e08"
import script from "./BankConfigureMollieTerminal.vue?vue&type=script&lang=ts"
export * from "./BankConfigureMollieTerminal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cb570e08')) {
      api.createRecord('cb570e08', component.options)
    } else {
      api.reload('cb570e08', component.options)
    }
    module.hot.accept("./BankConfigureMollieTerminal.vue?vue&type=template&id=cb570e08", function () {
      api.rerender('cb570e08', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/settings-default/BankConfigureMollieTerminal.vue"
export default component.exports